<template>
  <centered-layout
    :white="false"
    :horizontal="true"
    :vertical="true"
    class="contact-page"
  >
    <h1 class="heading heading--h1 text-center">CONTACT US</h1>
    <Info :message="printMessage" :class="extraClassInfo" v-if="isFormSumbited"/>
    <ContactForm :isFormValid="isFormValid" @update="formSubmited"/>
  </centered-layout>
</template>

<script>
import ContactForm from '@/components/Forms/ContactForm.vue';
import CenteredLayout from '@/components/UI/CenteredLayout.vue';
import Info from '@/components/UI/Info.vue';

export default {
  name: 'contact',
  components: {
    ContactForm,
    CenteredLayout,
    Info,
  },
  data() {
    return {
      message: {
        true: {
          value: 'Message sent! We will reply as soon as possible.',
        },
        false: {
          value: 'Sorry! You need to fill out all the required fields with valid data.',
        },
      },
      extraClassInfo: '',
      isFormValid: false,
      isFormSumbited: false,
    };
  },
  methods: {
    formSubmited(formValid) {
      this.extraClassInfo = formValid ? '' : 'info--danger';
      this.isFormValid = formValid;
      this.isFormSumbited = true;
      setTimeout(() => {
        this.isFormSumbited = false;
      }, 3300);
    },
  },
  computed: {
    printMessage() {
      return this.message[this.isFormValid].value;
    },
  },
};
</script>

<style scoped>

</style>
